import { GETTING_STARTED } from '~/app_constants';

export default {
  methods: {
    getTeamMemberById(id) {
      return this.teamMembers.find((member) => member.id === Number(id));
    },
    getImageAsset(name) {
      return GETTING_STARTED[name];
    },
  },
};
